import { EventDispatcher } from '../../eventdispatcher';
import PubSub from './pubsub';


export default class Channel extends EventDispatcher {

    client: PubSub
    key: string

    constructor(client: PubSub, key: string) {
        super()

        this.key = key
        this.client = client
    }


    handleData(data: any) {
        this.dispatch("data", data)
    }

}
